import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=5c5b3c0c&"
import script from "./ExpansionPanels.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExpansionPanels.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports